import { api } from './apiClient'

export const UploadsApi = {
  /**
   * Query uploads with OData-style paging.
   * @param {{ $top?: number, $skip?: number, $count?: boolean, uploadType?: string }} params
   * @returns {{ value: Upload[], '@odata.count'?: number }}
   */
  getUploads(params = {}) {
    return api.get('/api/uploads', params)
  },

  /**
   * Get a single upload by ID.
   */
  getUpload(uploadId) {
    return api.get(`/api/uploads/${uploadId}`)
  },

  /**
   * Get the latest COMPLETE (approved + processed) upload for an investment.
   * Returns 404 if none exists.
   */
  getLatestCompleteUpload(investmentId) {
    return api.get(`/api/uploads/investments/${investmentId}/latest-complete`)
  },

  /**
   * Validate a spreadsheet before uploading. Returns { valid, errors: [{msg, sheetName}] }.
   */
  validateUpload(file) {
    const formData = new FormData()
    formData.append('file', file)
    return api.upload('/api/uploads/validate', formData)
  },

  /**
   * Upload a new financials file (multipart).
   * @param {{ file: File, uploadType?: string, investmentId?: string, fundId?: string }} data
   */
  newFinancialsUpload(data) {
    const formData = new FormData()
    formData.append('file', data.file)
    formData.append('uploadType', data.uploadType || 'financials')
    if (data.investmentId) formData.append('investmentId', data.investmentId)
    if (data.fundId) formData.append('fundId', data.fundId)
    return api.upload('/api/uploads', formData)
  },

  /**
   * Update upload status (approve/reject).
   */
  updateUploadStatus(uploadId, newStatus) {
    return api.patch(`/api/uploads/${uploadId}/status`, { status: newStatus })
  },

  /**
   * Delete an upload.
   */
  deleteUpload(uploadId) {
    return api.delete(`/api/uploads/${uploadId}`)
  },

  /**
   * Download an uploaded file. Triggers browser save dialog.
   */
  downloadFile(uploadId, fallbackFilename) {
    return api.download(`/api/uploads/${uploadId}/download`, fallbackFilename)
  },

  /**
   * Download the blank XLSX upload template. Triggers browser save dialog.
   */
  downloadTemplate() {
    return api.download('/api/uploads/template', 'equivate-template.xlsx')
  }
}
